import React, { useState } from "react";
import {
  Box,
  Alert,
  Button,
  Typography,
  Stack,
  CircularProgress,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import apiClient from "../utils/apiClient";

const EmailVerificationNotice = ({ isVerified = false, email }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleResend = async () => {
    try {
      setLoading(true);
      setMessage("");
  
      const res = await apiClient.post("/api/vendor/resend-email-verification");
  
      if (res?.data?.success) {
        setMessage(res?.data?.message || "Verification email sent successfully!");
      } else {
        setMessage(res?.data?.message || "Something went wrong");
      }
  
    } catch (err) {
      setMessage(err?.response?.data?.message || "Failed to send email");
    } finally {
      setLoading(false);
    }
  };

  if (isVerified) return null;

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: "auto",
        mt: 4,
        p: 3,
        borderRadius: 3,
        boxShadow: 3,
        backgroundColor: "#fff",
      }}
    >
      <Stack spacing={2} alignItems="center">
        <EmailIcon sx={{ fontSize: 50, color: "orange" }} />

        <Typography variant="h6" fontWeight="bold" align="center">
          Email Not Verified
        </Typography>

        <Typography variant="body2" color="text.secondary" align="center">
          Your email <b>{email}</b> is not verified.  
          Please verify your email to access all features.
        </Typography>

        <Alert severity="warning" sx={{ width: "100%" }}>
          Please check your inbox and click the verification link.
        </Alert>

        <Button
          variant="contained"
          color="warning"
          fullWidth
          onClick={handleResend}
          disabled={loading}
          startIcon={!loading && <EmailIcon />}
        >
          {loading ? <CircularProgress size={20} /> : "Resend Verification Email"}
        </Button>

        {message && (
          <Typography variant="caption" color="primary">
            {message}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default EmailVerificationNotice;